<template>
    <div class="pv_settlement">
        <div class="form-box">
            <el-form
                :model="formModel"
                label-width="80px"
                inline
                label-position="left"
                class="leader-style-form"
            >
               
                <el-form-item label="月份" style="padding-left: 2%">
                    <el-date-picker
                        type="month"
                        placeholder="选择月份"
                        @change="getList()"
                        value-format="yyyy-MM"
                        v-model="formModel.year_month"
                        style="width: 100%;"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item style="float: right">
                    <el-button @click="getList">查询</el-button>
                    <el-button
                        type="primary"
                        size="medium"
                        @click="getExcel"
                    >导出</el-button
                    >
                </el-form-item>
            </el-form>
        </div>
        <div class="table-wrap" style="height: 90%;">
            <el-table class="leader-style-table" :data="tableData">
                <el-table-column width="50" align="center" label="序号">
                    <template slot-scope="scope">
                        <span>{{
                                    (pageNum - 1) * pageSize + scope.$index + 1
                                }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="月份"
                    align="center"
                    property="year_month"
                ></el-table-column>
                <el-table-column
                    label="并网柜发电量(kWh)"
                    align="center"
                    property="gf_power"
                ></el-table-column>
                <el-table-column
                    label="上网电量 (kWh)"
                    align="center"
                    property="sw_power"
                ></el-table-column>
                <el-table-column
                    label="结算电量 (kwh)"
                    align="center"
                    property="js_power"
                ></el-table-column>
                <el-table-column
                    label="结算单价 (kwh/元)"
                    align="center"
                    property="gf_price"
                ></el-table-column>
                <el-table-column
                    label="结算金额(元)"
                    align="center"
                    property="js_money"
                ></el-table-column>
                <el-table-column label="数据详情" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" class="leader-button" @click="getPvDetail(scope.row)">
                            <span class="inner-text">数据查看</span>
                        </el-button>

                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="leader-style-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                style="margin-top: 20px"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
    import * as api from "@/http/api.js";

    export default {
        components: {},
        data() {
            return {
                formModel: {
                    year_month: ""
                },
                tableData: [],
                pageNum: 1, //页码
                pageSize: 10, //每页条数
                currentPage: 1, //当前页码
                totalNum: 0, //总条数
            };
        },
        created() {
            
            this.getList();
        },
        methods: {
            //获取表头
            getList() {
                this.tableData=[];
                api.getList({
                    year_month: this.formModel.year_month,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize }).then(res => {
                    if (res) {
                        this.tableData = res.bus_json.items;
                        this.totalNum = res.bus_json.totalNum;
                    }
                });
            },
            getSysDate() {
                api.getSysDate1().then(res => {
                    if (res && res.error_code === "0") {
                        this.formModel.year_month = res.bus_json.sysdate3;
                        this.getList();
                    }
                });
            },
            getPvDetail(item){
                this.$router.push({ name:'pv_detail', query:{ year_month:item.year_month} })
            },
            /**
             * 导出excel表格
             */
            getExcel() {
                const loading = this.$loading({
                    lock: true,
                    text: '下载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
                api.getdfExcel({
                    year_month: this.formModel.year_month
                }).then((res) => {
                    if (res) {
                        const content = res;
                        const blob = new Blob([content]);
                        const fileName ='光伏电费结算.xlsx';
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blob, fileName);
                        } else {
                            let link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.download = fileName;
                            document.body.appendChild(link);
                            let evt = document.createEvent('MouseEvents');
                            evt.initEvent('click', false, false);
                            link.dispatchEvent(evt);
                            document.body.removeChild(link);
                        }
                        this.$message({
                            message: '下载成功！',
                            type: 'success',
                            duration:5000
                        });
                    }
                    loading.close();
                });
            },
            
            /**
             * 列表条数改变回调
             */
            handleSizeChange(e) {
                this.pageNum = 1;
                this.pageSize = e;
                this.getList();
            },
            /**
             * 企业列表页码改变回调
             */
            handleCurrentChange(e) {
                this.pageNum = e;
                this.getList();
            }
        }
    };
</script>
<style lang="scss">
    .pv_settlement {
        width: 100%;
        height: 100%;
        padding: 0 40px;
        box-sizing: border-box;
        // .el-table--border th {
        //     border: 1px solid #366a7f;
        // }
        .header-table {
            border: 1px solid #366a7f;
        }
        .header-table th {
            border: 1px solid #366a7f;
        }
    }
</style>
